import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref } from "vue";
export default {
  __name: 'emailDiv',
  setup(__props) {
    const email = ref("sales@jodell.cn");
    const toEmail = () => {
      var foxmailEmail = `mailto:${email}`;
      // 打开一个新窗口或者新标签，导航到Foxmail地址
      window.open(foxmailEmail, "_blank");
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "contentEmail",
        onClick: _cache[0] || (_cache[0] = $event => toEmail())
      }, _toDisplayString(email.value), 1);
    };
  }
};